import React from "react"

import tracking from "@irati-tracking/recognition/recognition"
import apps, {RECOGNITION} from "@irati-web/app/src/routeConfig"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"

const RecogniseButton: React.FC = () => {
  const onClick = () => {
    tracking.startCreateRecognition()
  }

  return (
    <ButtonRouterLink to="/polls/create" app={apps[RECOGNITION]} primary onClick={onClick}>
      <FormattedMessage id="recognition.banner.button" />
    </ButtonRouterLink>
  )
}
export default injectIntl(RecogniseButton)
